import Request from '@penguin/request'
import type { RequestConfig, IResponse } from '@penguin/request'
import { getToken } from './token'
import { domains } from './utils'

const requestInstance = new Request({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 1000 * 60 * 5,
  interceptors: {
    // 请求拦截器
    requestInterceptors: (config) => config,
    // 响应拦截器
    // eslint-disable-next-line
    responseInterceptors: (result) => {
      const { data } = result
      // 处理未登陆状态，需要登陆完成后重定向到当前页面
      if (data.code === 2) {
        // 如果是小程序跳转到小程序首页
        window.location.href = `${domains.h5}/login?redirect_url=${encodeURIComponent(
          window.location.href,
        )}`
      }
      return result
    },
  },
})

// 重写返回类型
interface IRequestConfig<T, R> extends RequestConfig<IResponse<R>> {
  data?: T
}

interface IRequestExtraConfig {
  formType?: boolean
}

/**
 * @description: 函数的描述
 * @generic D 请求参数
 * @generic T 响应结构
 * @param {IRequestConfig} config 不管是GET还是POST请求都使用data
 * @returns {Promise}
 */
export const request = <D = any, T = any>(
  config: IRequestConfig<D, T>,
  extraConfig: IRequestExtraConfig = { formType: true },
) => {
  const { method = 'GET', data = {} } = config
  const token = getToken()
  const tokenData: any = { ...data, token }
  if (method === 'get' || method === 'GET') {
    config.params = tokenData
  }
  const { formType } = extraConfig
  // 默认 POST 请求参数类型为 formData
  if (method === 'POST' && formType) {
    const formData: any = new FormData()
    for (const i in tokenData) {
      const item = tokenData[i]
      formData.append(i, typeof item === 'string' ? item : JSON.stringify(item))
    }
    config.data = formData
    config.headers = Object.assign(config.headers || {}, {
      'Content-Type': 'application/x-www-form-urlencoded',
    })
  }
  return requestInstance.request<T>(config)
}

// 取消请求
export const cancelRequest = (url: string | string[]) => {
  return requestInstance.cancelRequest(url)
}
// 取消全部请求
export const cancelAllRequest = () => {
  return requestInstance.cancelAllRequest()
}
